import { useEffect, useState } from 'react';
import { socket, joinRoom } from './socket';
import { api } from './api';
import type { OrderDto, SocketRoom } from '@taj/types';

/** Charge les commandes actives puis se tient à jour via Socket.IO. */
export function useLiveOrders(room: SocketRoom) {
  const [orders, setOrders] = useState<OrderDto[]>([]);
  const [live, setLive] = useState(socket.connected);

  useEffect(() => {
    let mounted = true;
    api.activeOrders().then((o) => mounted && setOrders(o)).catch(() => {});
    joinRoom(room);

    const upsert = (o: OrderDto) =>
      setOrders((prev) => {
        const rest = prev.filter((x) => x.id !== o.id);
        // on garde uniquement les commandes "actives"
        if (['COMPLETED', 'CANCELLED', 'CART'].includes(o.status)) return rest;
        return [o, ...rest];
      });

    const onNew = (o: OrderDto) => upsert(o);
    const onStatus = (p: { order: OrderDto }) => upsert(p.order);
    const onConnect = () => setLive(true);
    const onDisconnect = () => setLive(false);

    socket.on('order:new', onNew);
    socket.on('order:status', onStatus);
    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      mounted = false;
      socket.off('order:new', onNew);
      socket.off('order:status', onStatus);
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, [room]);

  return { orders, live, setOrders };
}
